import { create } from '@lottiefiles/lottie-interactivity';
import { Player } from '@lottiefiles/react-lottie-player';
import React, { useEffect, useRef, useState } from 'react';

export default function StepsAnimation() {
  const containerRef = useRef();
  const [playerIns, setPlayerIns] = useState(null);
  const [created, setCreated] = useState(false);

  const createAnimation = () => {
    if (created) return;

    setCreated(true);
    // console.log(playerIns);

    return create({
      mode: 'scroll',
      player: playerIns,
      container: containerRef.current,
      actions: [
        {
          visibility: [0.35, 0.7],
          type: 'seek',
          frames: [0, 100],
        },
      ],
    });
  }

  useEffect(() => {
    if (containerRef?.current && playerIns) {
      createAnimation();
    }
  }, [containerRef, playerIns]);

  return (
    <div ref={containerRef} className="h-full relative" id="steps-container">
      <div className="sticky top-[30vh]">
        <Player
          lottieRef={instance => setPlayerIns(instance)}
          rendererSettings={{ filterSize: {width: '200%',height: '200%',x: '-50%',y: '-50%'}}}
          src="/images/boom-howitworks-process.json"
        />
      </div>
  </div>
  )
}
